<div class="widget-exceptional-case-information">
  <div class="p-1">
    <mat-icon>{{ shownMessage()?.icon }}</mat-icon>
    <h5 class="mt-1 text-display-small">{{ shownMessage()?.message }}</h5>
  </div>
</div>
